import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { CdkModule } from '../cdk/cdk.module';
import {
    ClassifyPdfSelectionDialogComponent
} from '../classify-pdf-selection-dialog/classify-pdf-selection-dialog.component';
import { MaterialModule } from '../material/material.module';
import { PdfDocumentPreviewComponent } from './pdf-document-preview.component';
import { NgxCurrencyWrapperModule } from '../../shared/ngx-currency-wrapper.module';

@NgModule({
    declarations: [
        PdfDocumentPreviewComponent,
        ClassifyPdfSelectionDialogComponent
    ],
    exports: [
        PdfDocumentPreviewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MaterialModule,
        CdkModule,
        NgxExtendedPdfViewerModule,
        NgxCurrencyWrapperModule
    ]
})
export class PdfDocumentPreviewModule { }
